import {MenuItem} from "@mui/material";
import React from "react";
import {GetLookupMenuItems, GetLookupValueName} from "./LookupHelper";

export const GetTransferSide = (wallets, bankAccounts, type, value) => {
    if (type === 0) {
        let wallet = wallets.find(e => e.id === value);
        if (!wallet) {
            return 'Newcent';
        }
        return wallet.address;
    }
    let bankAccount = bankAccounts.find(e => e.id === value);
    if (!bankAccount) {
        return 'Newcent';
    }
    return bankAccount.iban;
}

export const GetTransferCryptoSides = (wallets, includeNewcentWallets = false, excludeId = null) => {
    let items = [];
    if (wallets) {
        wallets.forEach((elem) => {
            if (excludeId && elem.id === excludeId) {
                return;
            }
            if (!includeNewcentWallets) {
                if (elem.ownerId === Number(process.env.REACT_APP_NEWCENT_CONTACT_ID)){
                    return;
                }
            }

            let assetName = GetLookupValueName('asset', elem.assetId);
            items.push(
                <MenuItem key={elem.id} value={elem.id}>
                    {`${elem.address} (${assetName})`}
                </MenuItem>
            );
        });
    }
    return items;
}

export const GetTransferBankSides = (bankAccounts, includeNewcentAccounts = false, excludeId = null) => {
    let items = [];
    if (bankAccounts) {
        bankAccounts.forEach((elem) => {
            if (excludeId && elem.id === excludeId) {
                return;
            }
            let assetName = GetLookupValueName('asset', elem.assetId);
            items.push(
                <MenuItem key={elem.id} value={elem.id}>
                    {`${elem.iban} (${assetName})`}
                </MenuItem>
            );
        });
    }

    if (includeNewcentAccounts) {
        let ownAccounts = GetLookupMenuItems('ownBankAccounts', excludeId);

        if (ownAccounts) {
            items.push(ownAccounts);
        }
    }


    return items;
}